package org.teddapp.project.auth

/**
 * Abstraction de l'authentification biométrique (Touch ID, Face ID, fingerprint Android).
 *
 * Impls par cible :
 *  - androidMain : `AndroidBiometricAuthenticator` (BiometricPrompt)
 *  - iosMain : `IosBiometricAuthenticator` (LAContext)
 *  - jvmMain : `NoBiometric` (Mac/desktop — Touch ID nécessiterait un pont JNA)
 *  - tests : `NoBiometric` ou stub
 *
 * Chaque entry point d'application crée l'instance appropriée et la passe aux
 * écrans qui en ont besoin (LoginScreenPhone, LoginScreenWatch).
 */
interface BiometricAuthenticator {
    /** Le device a-t-il une empreinte/visage enrôlé et utilisable ? */
    suspend fun isAvailable(): Boolean

    /**
     * Déclenche le prompt biométrique natif.
     * `reason` est affiché à l'utilisateur (ex : "Déverrouille TEDD").
     */
    suspend fun authenticate(reason: String): BiometricResult
}

sealed interface BiometricResult {
    data object Success : BiometricResult
    data object Cancelled : BiometricResult
    data object NotAvailable : BiometricResult
    data class Error(val message: String) : BiometricResult
}

/** Fallback no-op : pour les cibles sans support biométrique (desktop V1, tests). */
class NoBiometric : BiometricAuthenticator {
    override suspend fun isAvailable(): Boolean = false
    override suspend fun authenticate(reason: String): BiometricResult = BiometricResult.NotAvailable
}
